import styled from '@emotion/styled'

import theme from 'styles/theme'

export const CategoryButton = styled.button<{ isCategorySelected: boolean }>`
  color: ${theme.token.var('colors.white')};
  padding: 14px 12px;
  border-radius: ${theme.token.var('borderRadius.small')};
  transition: background 0.2s ease;
  background: ${({ isCategorySelected }) =>
    isCategorySelected ? theme.token.var('colors.green.a150') : 'transparent'};
  cursor: pointer;

  &:hover {
    background: ${theme.token.var('colors.green.a150')};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`
